<template>
  <v-card-text style="text-align: center">
    <v-card
      style="margin-bottom: 4px"
      variant="elevated"
      @click="NavigationHelper.openForm(router, Forms.PROFILE)"
    >
      <v-card-text>{{ i18n.t('buttons.profile') }}</v-card-text>
    </v-card>
    <v-card
      style="margin-bottom: 4px"
      variant="elevated"
      @click="NavigationHelper.openForm(router, Forms.SERVICES)"
    >
      <v-card-text>{{ i18n.t('buttons.services') }} ({{ userStore.services.length }})</v-card-text>
    </v-card>
    <v-dialog max-width="500">
      <template #activator="{ props: activatorProps }">
        <v-card
          v-if="hasWordpressAccess(userStore.services)"
          style="margin-bottom: 4px"
          variant="elevated"
          v-bind="activatorProps"
          @click="
            requestKey = true;
            getApiKey();
          "
        >
          <v-card-text>{{ i18n.t('buttons.getkey') }}</v-card-text>
        </v-card>
      </template>

      <template #default="{ isActive }">
        <v-card :title="i18n.t('texts.notimplemented')">
          <!--      <v-card v-if="requestKey" :title="i18n.t('texts.overwritekeytitle')">-->
          <!--&lt;!&ndash;        <v-card v-if="requestKey">&ndash;&gt;&ndash;&gt;-->
          <!--                    <v-card-text>-->
          <!--                      {{ i18n.t("texts.currentkey") }} {{ getExpWordpressToken() }}-->
          <!--                      <v-divider></v-divider>-->
          <!--                      {{ userStore.userInfo.wordpressApiKey }}-->
          <!--                      <v-divider></v-divider>-->
          <!--                      {{ i18n.t("texts.overwritekey") }}-->
          <!--                    </v-card-text>-->
          <!--                    <v-divider></v-divider>-->
          <!--                    <v-card-actions>-->
          <!--                      <v-spacer></v-spacer>-->
          <!--                      <v-btn @click="dialog = true; getNewKey = true; getApiKey()">-->
          <!--                        Ok-->
          <!--                      </v-btn>-->
          <!--                      <v-btn @click="dialog = false">-->
          <!--                        Cancel-->
          <!--                      </v-btn>-->
          <!--                    </v-card-actions>-->
          <!--                  </v-card>-->
          <!--        <v-card v-else>-->
          <!--          <v-card-title>-->
          <!--            {{ i18n.t("texts.newapikey") }}-->
          <!--          </v-card-title>-->
          <!--          <v-card-text>-->
          <!--            <v-divider></v-divider>-->
          <!--            {{ userStore.userInfo.wordpressApiKey }}-->
          <!--          </v-card-text>-->
          <!--          <v-divider></v-divider>-->
          <!--          <v-card-actions>-->
          <!--            <v-spacer></v-spacer>-->
          <!--            <v-btn @click="dialog = false;">-->
          <!--              Ok-->
          <!--            </v-btn>-->
          <!--          </v-card-actions>-->

          <v-card-actions style="text-align: end">
            <PolteqButton
              button-id="closeButton"
              icon="mdi-close"
              :button-text="i18n.t('buttons.close')"
              @click="isActive.value = false"
            />
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-card-text>
</template>

<script lang="ts" src="./IDOverview.ts" />
